module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.1dc35d25.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/font-awesome-4.6.3/fonts/fontawesome-webfont.ttf?v=4.6.3
 ** module id = 1359
 ** module chunks = 0
 **/